import React from 'react';

const FilterIcon = ({
  width = 26,
  height = 26,
  color = '#7F38E9',
  showCircle = true,
  circleColor = 'var(--border-default)',
  ...rest
}) => {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      {showCircle && <circle cx="13" cy="13" r="12.5" fill="white" stroke={circleColor} />}
      <path
        d="M17.6654 8H8.33203C7.38936 8 6.91803 8 6.62536 8.27467C6.33203 8.54933 6.33203 8.992 6.33203 9.87667V10.3367C6.33203 11.028 6.33203 11.374 6.50536 11.6607C6.6787 11.9473 6.99403 12.126 7.6267 12.482L9.5687 13.5753C9.9927 13.814 10.2054 13.9333 10.3574 14.0653C10.6734 14.3393 10.868 14.662 10.956 15.0587C10.9987 15.248 10.9987 15.4707 10.9987 15.9153V17.6953C10.9987 18.3013 10.9987 18.6047 11.1667 18.8407C11.3347 19.0773 11.6334 19.194 12.2294 19.4273C13.482 19.9167 14.108 20.1613 14.5534 19.8827C14.9987 19.6047 14.9987 18.968 14.9987 17.6947V15.9147C14.9987 15.4707 14.9987 15.248 15.0414 15.058C15.1251 14.6694 15.336 14.3199 15.6407 14.0647C15.792 13.9333 16.0047 13.814 16.4287 13.5747L18.3707 12.4813C19.0027 12.126 19.3194 11.948 19.492 11.6613C19.6654 11.3747 19.6654 11.028 19.6654 10.336V9.876C19.6654 8.992 19.6654 8.54933 19.372 8.27467C19.08 8 18.6087 8 17.6654 8Z"
        stroke={color}
      />
    </svg>
  );
};

export default React.forwardRef(FilterIcon);
